module.exports = __webpack_public_path__ + "img/total-blue.b63ba03b.svg";